import { Component } from '@angular/core';

@Component({
       selector: 'throbber',
    templateUrl: './throbber.component.html',
      styleUrls: [ './throbber.component.css' ]

})
export class ThrobberComponent { }
